/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invest_Investinfolink2Inputs */

const en_invest_investinfolink2 = /** @type {(inputs: Invest_Investinfolink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take 2 minutes to learn more`)
};

/**
* | output |
* | --- |
* | "Take 2 minutes to learn more" |
*
* @param {Invest_Investinfolink2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const invest_investinfolink2 = /** @type {((inputs?: Invest_Investinfolink2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invest_Investinfolink2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_invest_investinfolink2(inputs)
});
export { invest_investinfolink2 as "invest_investInfoLink" }